<template>
  <div class="content-box">
    <div class="title-img">
      <img src="@/assets/registeredAgent/icon.png" alt="" />
    </div>
    <div class="title-text">注册联动pay展业版</div>
    <div class="from-box">
      <div class="item-box">
        <span class="label codeNum">推荐码：</span> <span class="label">{{ from.recommendCode }}</span>
      </div>
      <div class="item-box">
        <van-field label="账号" v-model="from.phone" type="digit" maxlength="11" placeholder="请输入登录手机号" />
        <van-divider :hairline="false" class="divider-style" />
      </div>
      <div class="item-box code">
        <van-field label="验证码" v-model.trim="from.smsCode" maxlength="4" placeholder="请输入验证码">
          <template #button>
            <!-- <div class="code-btn" @click="getVerifyCodeEvent">
              <van-loading v-if="loadingCaptcha" color="#FF4741" type="spinner" size="14px" class="captcha-loading">
                {{ codeBtnText }}</van-loading
              >
              <span v-else>{{ codeBtnText }}</span>
            </div> -->
            <van-button
              size="small"
              @click="getVerifyCodeEvent"
              :loading="loadingCaptcha"
              loading-type="spinner"
              type="primary"
              >{{ codeBtnText }}</van-button
            >
          </template>
        </van-field>
        <van-divider :hairline="false" class="divider-style" />
      </div>
      <div class="item-box">
        <van-field
          label="密码"
          v-model.trim="from.password"
          :type="eyeShow ? 'text' : 'password'"
          clearable
          :right-icon="eyeShow ? eye2 : eye"
          @click-right-icon="rightIcon"
          placeholder="请设置登录密码"
        />
        <van-divider :hairline="false" class="divider-style" />
      </div>
      <div class="submit-btn" @click="submit">
        <van-loading v-if="loadingBtn" type="spinner" size="20px" class="btn-loading">立即注册</van-loading>
        <span v-else>立即注册</span>
      </div>
    </div>
    <div class="checkbox-style">
      <van-checkbox v-model="checkboxValue" checked-color="#FF4741" icon-size="17px">请阅读并勾选</van-checkbox
      ><span class="label" @click="goAgreement">《APP用户服务协议》</span>与<span class="label" @click="goPrivacy"
        >《隐私政策》</span
      >
    </div>
    <van-dialog
      v-model="captchaShow"
      title="图形验证码"
      show-cancel-button
      :before-close="captchaConfirm"
      @open="captchaOpen"
    >
      <div class="code-box">
        <div class="code-img" @click="captchaOpen">
          <img v-if="imgUrl && !captchaError" :src="imgUrl" alt="" />
          <div v-else class="replay-box"><van-icon name="replay" />&nbsp;点击重试</div>
        </div>
        <div class="code-input">
          <van-field v-model="captcha" maxlength="6" placeholder="请输入图形验证码" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { agentSms, agentAdd, getCaptcha } from "@/api/registeredAgent";
import { Toast } from "vant";
import sha1 from "sha1";
import { shareConfig } from "@/utils/share.js";

export default {
  data() {
    return {
      eye: require("../../assets/registeredAgent/eye.png"),
      eye2: require("../../assets/registeredAgent/eye2.png"),
      from: {
        recommendCode: this.$route.query.recommendCode,
        // recommendCode: "28007859",
        phone: "",
        smsCode: "",
        password: "",
      },
      checkboxValue: false,
      codeBtnText: "获取验证码",
      codeBtnDisable: true,
      quickLink: "",
      title: "",
      isCaptcha: 0,
      captchaShow: false,
      imgUrl: "",
      captcha: "",
      captchaKey: "",
      captchaError: false,
      eyeShow: false,
      loadingBtn: false,
      loadingCaptcha: false,
      title: "<联动pay展业版>快速注册",
      desc: "联动pay展业助手、功能强大、操作便捷、数据清晰，立即下载App开始使用吧！",
      imgUrl: "https://oss.umfpay.com/image/ac/6f/e0/44/80b978e4bf1d4ad39f9b4b30b254e4b5.png", //展业logo
    };
  },
  created() {
    // this.getProtocol();
  },
  mounted() {
    shareConfig(this.title, this.desc, this.imgUrl);
  },
  methods: {
    rightIcon() {
      this.eyeShow = !this.eyeShow;
    },
    // 获取验证码效验
    getVerifyCodeEvent() {
      if (this.loadingCaptcha) {
        return;
      }
      if (!this.codeBtnDisable) {
        return;
      }
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;

      if (!this.from.phone) {
        Toast({
          message: "手机号码不能为空",
          icon: "cross",
        });
        return false;
      }
      if (!strTemp.test(this.from.phone)) {
        Toast({
          message: "手机号码格式不正确",
          icon: "cross",
          duration: 2 * 1000,
        });
        return false;
      }
      if (this.isCaptcha === 1) {
        this.captchaShow = true;
      } else {
        let params = {
          phone: this.from.phone,
          type: 0,
        };
        this.sendRequestCode(params);
      }
    },
    // 打开弹窗调取图形验证码接口
    captchaOpen() {
      getCaptcha()
        .then((res) => {
          this.captchaError = false;
          this.imgUrl = res.captcha;
          this.captchaKey = res.captchaKey;
        })
        .catch((err) => {
          this.captchaError = true;
          this.imgUrl = "";
          this.captchaKey = "";
        });
    },
    // 弹窗获取短息验证码
    captchaConfirm(action, done) {
      if (action === "confirm") {
        if (this.captcha == "") {
          Toast({
            message: "请输入图形验证码",
            duration: 2 * 1000,
            icon: "cross",
          });
          done(false);
          return;
        }
        let params = {
          phone: this.from.phone,
          captcha: this.captcha,
          captchaKey: this.captchaKey,
        };
        this.sendRequestCode(params);
        done();
        this.captcha = "";
      } else {
        done();
        this.captcha = "";
      }
    },
    // 获取验证码接口
    sendRequestCode(data) {
      this.loadingCaptcha = true;
      agentSms(data)
        .then((res) => {
          this.loadingCaptcha = false;
          this.isCaptcha = res;
          let time = 60,
            i = 0;
          this.codeBtnText = --time + "s后重新获取";
          let timer = setInterval(() => {
            this.codeBtnText = --time + "s后重新获取";
            i++;
            if (i == 1) {
              this.codeBtnDisable = false;
            }
          }, 1000);
          setTimeout(() => {
            this.codeBtnText = "获取验证码";
            this.codeBtnDisable = true;
            clearInterval(timer);
          }, time * 1000);
        })
        .catch((err) => {
          this.loadingCaptcha = false;
          if (err.code === 5001) {
            this.isCaptcha = 1;
            this.captchaShow = true;
          } else {
            Toast({
              message: err.message,
              icon: "cross",
            });
          }
        });
    },
    // 立即注册
    submit() {
      if (this.loadingBtn) {
        return;
      }
      if (!this.checkboxValue) {
        Toast({
          message: "请先阅读并勾选协议",
          duration: 2 * 1000,
          icon: "cross",
        });
        return;
      }
      if (this.from.phone === "") {
        Toast({
          message: "请填写登录手机号",
          duration: 2 * 1000,
          icon: "cross",
        });
        return;
      }
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!strTemp.test(this.from.phone)) {
        Toast({
          message: "手机号码格式不正确",
          icon: "cross",
          duration: 2 * 1000,
        });
        return false;
      }
      if (this.from.smsCode === "") {
        Toast({
          message: "请输入动态验证码",
          duration: 2 * 1000,
          icon: "cross",
        });
        return;
      }
      if (this.from.password === "") {
        Toast({
          message: "请输入密码",
          duration: 2 * 1000,
          icon: "cross",
        });
        return;
      }
      if (this.from.password.length < 6 || this.from.password.length > 15) {
        Toast({
          message: "请输入6-15位密码",
          duration: 2 * 1000,
          icon: "cross",
        });
        return;
      }
      let pwdTest = /^[0-9a-zA-Z]*$/g;
      if (!pwdTest.test(this.from.password)) {
        Toast({
          message: "请输入数字、字母、字母+数字组合的密码",
          duration: 2 * 1000,
          icon: "cross",
        });
        return;
      }

      this.loadingBtn = true;
      this.from.account = this.from.phone;
      let params = JSON.parse(JSON.stringify(this.from));
      // params.password = sha1(params.password);
      agentAdd(params)
        .then((res) => {
          Toast("注册成功");
          this.loadingBtn = false;
          this.$router.push("agentDownload");
        })
        .catch((err) => {
          this.loadingBtn = false;

          Toast({
            message: err.message,
            icon: "cross",
          });
        });
    },
    // 查看协议
    goAgreement() {
      this.$router.push({
        path: "/agreement",
        // query: {
        //   url: this.quickLink,
        //   title: this.title,
        // },
      });
    },
    //查看隐私政策
    goPrivacy() {
      this.$router.push({
        path: "/privacy",
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .van-button--primary {
  background-color: #fff3f2;
  border: 1px solid #fff3f2;
  color: #ff4741;
}
/deep/ .van-field__label {
  width: 100px;
}
/deep/ .code .van-field__label {
  line-height: 70px;
}
.content-box {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f5f5f5;
  .title-img {
    margin: 65px auto 0px;
    width: 198px;
    height: 198px;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  .title-text {
    padding: 0 10px;
    font-size: 36px;
    height: 66px;
    line-height: 66px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .from-box {
    padding: 52px 48px;
    box-sizing: border-box;
    width: 698px;
    height: 760px;
    margin: 53px auto 55px;
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    .item-box {
      margin-bottom: 34px;
      .label {
        font-size: 30px;
        color: #333;
        font-weight: bold;
      }
      .codeNum {
        font-size: 32px;
        font-weight: bold;
      }
      .divider-style {
        margin: 0;
      }
      .code-btn {
        font-size: 26px;
        color: #ff4741;
        // width: 180px;
        // height: 70px;
        // line-height: 70px;
        // text-align: center;
        // background: #fff3f2;
        // border-radius: 8px;
        .van-loading__text {
          color: #ff4741;
          font-size: 26px;
        }
      }
    }
    .submit-btn {
      margin: 84px auto 0;
      width: 602px;
      height: 94px;
      line-height: 94px;
      text-align: center;
      background-color: #ff4741;
      border-radius: 6px;
      font-size: 32px;
      font-weight: 500;
      color: #ffffff;
      .btn-loading {
        color: #ffffff;
        .van-loading__text {
          color: #ffffff;
          font-size: 32px;
        }
      }
    }
  }
  .checkbox-style {
    margin: 55px 0 0;
    font-size: 24px;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    .label {
      font-size: 24px;
      color: #ff4741;
    }
  }
}
.code-box {
  margin: 20px 0 40px;
  display: flex;
  justify-content: space-between;
  .code-img {
    width: 238px;
    height: 86px;
    border: 1px solid #e8e8e8;
    .replay-box {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      color: #ff6b03;
    }
    > img {
      width: 100%;
      height: 100%;
    }
  }
  .code-input {
    width: 276px;
    padding-left: 20px;
    border: 1px solid #e8e8e8;
  }
}
</style>
